import { API_MASTER_DATA } from '../../service/index'
import axios from 'axios'

export default {
  state: {
    RestaurantData: null,
    currency: 'THB'
  },
  mutations: {
    setRestaurantData (state, RestaurantData) {
      state.RestaurantData = RestaurantData
    },
    setCurrency (state, currency) {
        state.currency = currency
    },
  },
  actions: {
    async getRestaurantDetail ({commit, state}, payload) {
      // return new Promise(function (resolve, reject) {
        var data = await axios({
          method: 'GET',
          url: API_MASTER_DATA + 'restaurants/' + payload.restaurant_uuid + '/contact-us',
          responseType: 'json',
        }).then((response) => {
          if (response.data.meta.status === 200) {
            commit('setRestaurantData', response.data.data)
            return response.data.data
          }
        }).catch(() => {
          return []
        })
        return data
      // })
    },
    async getAliasDetail ({commit}, payload) {
      var url = (payload.branch) ? `${API_MASTER_DATA}restaurants/aliases?restaurant=${payload.restaurant}&branch=${payload.branch}` : `${API_MASTER_DATA}restaurants/aliases?restaurant=${payload.restaurant}`
      var data = await axios({
        method: 'GET',
        url: url
      }).then((response) => {
        if (response.data.meta.status === 200){
          commit('setCurrency', response.data.data.currency)
          return response.data.data
        } else if (response.data.meta.status === 404) return null
        else return []
      }).catch((err) => {
        return []
      })
      return data
    }
  },
  getters: {
    RestaurantData (state) {
      return state.RestaurantData
    },
    currency (state) {
      return state.currency
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/restaurant/index.js